import { FilterInfo } from 'lib-shared-types-api';

import { FilterLink } from '../shared';

type FailedFilterStatusProps = {
  filter: FilterInfo;
  statusText: string;
};

/** Displays status for filters that failed or had incomplete evaluation. */
export const FailedFilterStatus = ({
  filter,
  statusText,
}: FailedFilterStatusProps): JSX.Element => {
  return (
    <>
      Filter: <FilterLink filter={filter} />
      {statusText && ` ${statusText}`}
    </>
  );
};
